<router-outlet />
@if (!isPublicPage) {
  <app-configuration />
}
